import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  HasImpactSummaries,
  NewLabelIS,
} from 'src/app/shared/interfaces/header.interface';
import { ApiService } from 'src/app/shared/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private clickedReportsTab: boolean = false;
  private reportsTabClick = new BehaviorSubject<boolean>(false);
  reportsTabClick$ = this.reportsTabClick.asObservable();

  newLabelIS = signal<NewLabelIS | null>(null);

  constructor(private api: ApiService) {}

  setClick() {
    this.clickedReportsTab = !this.clickedReportsTab;
    this.reportsTabClick.next(this.clickedReportsTab);
  }

  getHasAccessImpactSummaries(): Observable<HasImpactSummaries> {
    const url = 'impact_summary/has-access-impact-summaries/';
    return this.api.get(url);
  }

  loadNewLabelIS() {
    this.getHasAccessImpactSummaries().subscribe({
      next: (res: HasImpactSummaries) => {
        this.newLabelIS.set(res);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }
}
